import type { EventInput } from '@fullcalendar/core/index.js'
import type { WithID } from '@tunasong/models'
import type { CalendarEvent } from '@tunasong/schemas'

export const toFullCalendarEvent = ({
  id,
  start,
  end,
  name,
  description,
  allDay,
}: WithID<CalendarEvent>): EventInput => ({
  id,
  title: name,
  description,
  start: start ?? undefined,
  end: end ?? undefined,
  allDay,
})
